import React from 'react';
import {Table} from 'antd';
import Screen from '../utils/screen';
import "./ListView.css";

export default class ResponsiveTable extends React.Component {
  static propTypes = {
    ...Table.propTypes,
  };

  render() {
    const {filters, sorter, columns, components, showHeader, pagination, ...rest} = this.props;
    const isMobile = ['xs', 'sm'].includes(Screen.size);
    const tableColumns = columns.map(column => {
      const {sorter: columnSorter, filters: columnFilters, render: columnRender, title} = column;
      if (columnSorter) {
        column = {...column, sortOrder: (sorter && sorter.field === column.dataIndex && sorter.order) || false};
      }
      if (columnFilters) {
        column = {...column, filteredValue: (filters && filters[column.key]) || []};
      }
      if (isMobile) {
        delete column.fixed;
        delete column.width;
        column = {
          ...column, render: (value, record, index) => ([
            <div key="title" className="ind-table-cell-title">{title}</div>,
            <div key="content" className="ind-table-cell-content">
              {columnRender ? columnRender(value, record, index) : value}
            </div>,
          ])
        };
      }
      return column;
    });
    const showTableHeader = isMobile ? false : showHeader;
    const tableComponents = isMobile ? {
      ...components,
      table: props => <div className="ind-table">{props.children[2]}</div>, // 0 = ColGroup, 1 = Header
      header: {
        wrapper: () => null,
        row: () => null,
        cell: () => null,
      },
      body: {
        wrapper: props => <div className="ind-table-body">{props.children}</div>,
        row: props => <div className="ind-table-row">{props.children}</div>,
        cell: props => <div className="ind-table-cell">{props.children}</div>,
      }
    } : {};
    const tablePagination = pagination === false ? pagination :
      isMobile ? {
        ...pagination,
        position: 'both',
        size: Screen.width < 362 && 'small',
      } : pagination;
    return (
      <Table
        showHeader={showTableHeader}
        components={tableComponents}
        columns={tableColumns}
        filters={filters}
        sorter={sorter}
        pagination={tablePagination}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ResponsiveTable.js